/**
 * CartCounter Directive
 * Matches TypeScript cart-counter.directive.ts exactly
 * Updates cart counter display when cart changes
 */
// @ts-nocheck
import { ThemeEvents } from '@theme/events';
import CartManager from '@theme/cart-manager';

class CartCounter {
  static selector = '[cart-counter]';

  constructor(hostElement) {
    this.host = hostElement;
    this.prefix = hostElement.getAttribute('cart-counter-prefix') || '';
    this.suffix = hostElement.getAttribute('cart-counter-suffix') || '';
    this.suffixPlural = hostElement.getAttribute('cart-counter-plural') || 's';
    this.cartEmptyClass = hostElement.getAttribute('cart-empty-class') || '';

    this.init();
  }

  init() {
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate.bind(this));
    this.renderFromKnownCart();
  }

  renderFromKnownCart() {
    const managerCart = CartManager.getInstance().getState();
    if (managerCart) {
      this.updateString(window.getCartItemCount(managerCart));
      return;
    }

    const bootstrapCart = window.getBootstrapCart?.();
    if (bootstrapCart) {
      this.updateString(window.getCartItemCount(bootstrapCart));
      return;
    }

    this.updateFromCart();
  }

  onCartUpdate(event) {
    const cart = event?.detail?.resource?.cart;
    if (cart) {
      this.updateString(window.getCartItemCount(cart));
      return;
    }

    const managerCart = CartManager.getInstance().getState();
    if (managerCart) {
      this.updateString(window.getCartItemCount(managerCart));
      return;
    }

    if (event?.detail?.data?.itemCount !== undefined) {
      CartManager.getInstance()
        .get()
        .then((freshCart) => {
          if (freshCart) this.updateString(window.getCartItemCount(freshCart));
        })
        .catch(() => this.updateFromCart());
      return;
    }

    this.updateFromCart();
  }

  async updateFromCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateString(window.getCartItemCount(cart));
    } catch (e) {
      console.error('Error fetching cart for counter:', e);
    }
  }

  updateString(value) {
    this.host.textContent = this.buildString(value);

    if (this.cartEmptyClass) {
      if (value <= 0) {
        this.host.classList.add(this.cartEmptyClass);
      } else {
        this.host.classList.remove(this.cartEmptyClass);
      }
    }
  }

  buildString(value = 0) {
    const { prefix, suffix, suffixPlural } = this;
    if (suffix && value > 1) {
      return `${prefix}${value}${suffix}${suffixPlural}`;
    }
    return `${prefix}${value}${suffix}`;
  }

  destroy() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }
}

function initCartCounter() {
  const counterElements = document.querySelectorAll(CartCounter.selector);
  counterElements.forEach((element) => {
    if (!element.cartCounterInstance) {
      element.cartCounterInstance = new CartCounter(element);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartCounter);
} else {
  initCartCounter();
}

document.addEventListener('shopify:section:load', initCartCounter);

export default CartCounter;
